// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u7Yb+","footer__content":"Footer_footer__content__AKnjN","social__links":"Footer_social__links__0ZZUg","legal__items":"Footer_legal__items__30qlJ"};